export function debouncify(originalMethod, delayMs) {
  let handler;
  return function (...args) {
    clearTimeout(handler);
    handler = setTimeout(() => {
      originalMethod.apply(this, args);
    }, delayMs);
  };
}
